<template>
    <div class="investment-align-mobile" >

<!-- Abdullah responsive added mx-3  -->
        <div class="row no-gutters py-2 mb-3 ml-3 custom-mobile-left-side-alignment-margin">
          <div class="col-md-10 col-sm-12" >
            <h4 class="atlhr-dashboard-title mt-10">
                 Advance <span class="black-title">Income Tax</span>
                <span>
                    <a v-bind:href="$api_url">Dashboard</a>
                    / Tax Reducers / Advance Income Tax
                </span>
            </h4>
          </div>
        </div>


       <template  v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
        <!-- Abdullah responsive added mx-3  -->
        <div class="clearfix company-form-container ml-3 dashboard-mobile-margin-right">
            <div class="p-3 employee-investment-wrapper">
                <div class="" >
                    <div class="row no-gutters py-2 mb-3">
                        <div class="col-sm-5 company-form-box-title">Advance Income Tax History</div>
                        <div class="col-sm-7 cursor-pointer text-right company-form-box-title">
                            <select id="year" v-model="year" name="year" class="form-control custom-select investment-select">
                                    <option v-for='pyr in payrunyears'  :value='pyr.value'>{{ pyr.text }}</option>
                            </select>
                            <button class="btn btn-block btn-secondary tab-button add-investment" @click="addNew()">Add Advance Income Tax</button>
                        </div>
                    </div>

                    <div class="row col-md-12 mb-4 no-margin px-0" v-if="year != null && Object.keys(aits[year] || {}).length > 0">
                        <div class="investment-total-text-box">Total Advance Income Tax Recorded For {{aits[year].fiscal_year}} : <span style="float:right;">&nbsp;&nbsp; &#2547 {{formatMoney(aits[year].total)}} </span></div>
                    </div>

                    <!-- added total approved amount for ait -afrin -->
                    <div class="row col-md-12 mb-4 no-margin px-0"
                        v-if="year != null && Object.keys(aits[year]).length > 0">
                        <div class="investment-total-text-box">Total Approved AIT For
                            {{ aits[year].fiscal_year }} : <span style="float:right;">&nbsp;&nbsp; &#2547
                                <template v-if="decimal_setting == 'no'">{{
                                    moneyFormat(Math.round(aits[year].total_approved)) }}</template><template
                                    v-else>{{ moneyFormat(aits[year].total_approved) }}</template> </span></div>
                    </div>
                    <!-- end added total approved amount for ait -afrin -->

                    <div class="employee-table-wrapper table-sticky-height">
                        <table class="employee-list-table dataTable table-overflow table-sticky ess-custom-table">
                            <thead>
                                <tr class="table-head ">
                                    <td>  <label class="custom-label"><span>Fiscal Year</span></label> </td>
                                    <td><label class="custom-label "><span>Month</span></label> </td>
                                    <td> <label class="custom-label "><span>Amount</span></label>   </td>
                                    <td> <label class="custom-label "><span>Status</span></label> </td>
                                    <!-- Mustafijur: 19-05-2026: Commented -->
                                    <!-- <td> <label class="custom-label "><span> Created By</span></label>  </td>
                                    <td>  <label class="custom-label "><span>Updated By</span></label>  </td> -->
                                    <!-- Mustafijur: 19-05-2026: Commented -->
                                    <td>  <label class="custom-label "><span>Last Activity <span class="custom-date-indicator">(YYYY-MM-DD)</span></span></label>  </td>
                                    <td> <label class="custom-label "><span>Action</span></label> </td>
                                </tr>
                            </thead>
                            <template v-if="year != null">
                                <tbody>
                                    <tr class="hover-bg table-row" v-for="ait_details in aits[year].details" :key="ait_details.id">

                                        <td class="cursor-pointer trz_relative">
                                            <label class="mb-0 custom-label">{{ait_details.fiscal_year}}</label>
                                        </td>
                                        <td class="cursor-pointer trz_relative">
                                            <div class=" text-center">
                                                <template v-for="mnr in months">
                                                    <template v-if="mnr.value == ait_details.month">{{mnr.text}}</template>
                                                </template>
                                            </div>
                                        </td>
                                        <td class="cursor-pointer trz_relative text-right">
                                            {{moneyFormat(ait_details.amount)}}
                                        </td>
                                        <td class="cursor-pointer trz_relative">
                                            <div class=""><template v-if="ait_details.status == 1"><b-icon icon="check-circle-fill" variant="success" class="mr-2"></b-icon></template><template v-else><b-icon icon="dash-circle-fill" variant="warning" class="mr-2"></b-icon></template>{{ statusMap[ait_details.status] }}</div>
                                        </td>
                                        <!-- Mustafijur: 19-05-2026: Commented -->
                                        <!-- <td class="cursor-pointer trz_relative">
                                            <template>{{ait_details.created_by}}</template>
                                        </td>
                                        <td class="cursor-pointer trz_relative">
                                            <template>{{ait_details.updated_by}}</template>
                                        </td> -->
                                        <!-- Mustafijur: 19-05-2026: Commented -->
                                        <td class="cursor-pointer trz_relative">
                                            <template v-if="ait_details.updated_at != null">{{ formatMe(ait_details.updated_at) }}</template>
                                            <template v-else>{{ formatMe(ait_details.created_at) }}</template>
                                        </td>

                                        <!-- Abdullah responsive added text-right  -->
                                        <td class="cursor-pointer trz_relative text-right">
                                            <div class="col-sm clearfix px-0" v-if="flg > 0">
                                                <template v-if="canModifyAit(ait_details, aits[year].approver_enabled)">
                                                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle text-right" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                                    <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                        <b-button-toolbar class="">
                                                            <b-button-group class="">
                                                                <!-- Abdullah responsive chnaged title  -->
                                                                <b-button title="Edit Advance Income Tax History" @click="editAit(ait_details.id)">
                                                                    <i class="fa fa-pencil-alt"></i> Edit
                                                                </b-button>
                                                                <!-- Abdullah responsive chnaged title  -->
                                                                <b-button title="Delete Advance Income Tax History" @click="deleteAit(ait_details.id)">
                                                                    <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                                                                </b-button>
                                                            </b-button-group>
                                                        </b-button-toolbar>
                                                    </div>
                                                </template>

                                                <div class="text-right" v-else title="This AIT declaration cannot be edited or deleted since a pay run has been approved after this was listed." v-b-tooltip placement="right">
                                                    <b-icon icon="info-circle"></b-icon>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                            <template v-else>
                                <tr class="hover-bg table-row">
                                    <td class="cursor-pointer trz_relative text-center" colspan="7">No Advance Income Tax found</td>
                                </tr>
                            </template>

                        </table>
                    </div>




                </div>
            </div>
        </div>

    </template>
    <template v-else>
        <lock-template ></lock-template>
    </template>

    <b-modal id="bv-modal-example" size="lg" :modal-class="'w-600'" hide-footer :title="modal_title"> <!-- Mustafijur: 18-05-2026 -->
        <b-form @submit.stop.prevent="onSubmit">
            <div class="clearfix">

                <div class="col-md-12">

                    <input type="hidden" v-model="fdata.id" name="id">
                    <b-form-group id="fiscal_year-group" label="Fiscal Year" class="required-field" label-for="fiscal_year">
                        <!--<b-form-input id="fiscal_year" name="fiscal_year" v-model="fdata.fiscal_year" readonly></b-form-input>-->
                        <b-form-select id="fiscal_year" name="fiscal_year" v-model="fdata.fiscal_year" :options="fiscal_years"  v-validate="{ required: true }" :state="validateState('fiscal_year')" aria-describedby="gender-feedback" data-vv-as="Fiscal Year"></b-form-select>
                        <b-form-invalid-feedback id="fiscal_year-feedback">{{ veeErrors.first('fiscal_year') }}</b-form-invalid-feedback>
                    </b-form-group>


                    <b-form-group id="month-group" label="Month" label-for="month">
                        <b-form-select id="month" name="month" v-model="fdata.month" :options="months" ></b-form-select>
                    </b-form-group>

                    <b-form-group id="amount-group" label="AIT Amount ( ৳ )" class="required-field" label-for="amount">
                        <b-form-input id="amount" name="amount" v-model="fdata.amount" v-validate="{ required: true, regex: /^(?=.*[1-9])\d+(\.\d+)?$/ }" :state="validateState('amount')" aria-describedby="amount-feedback" data-vv-as="Amount"></b-form-input>
                        <b-form-invalid-feedback id="amount-feedback">{{ veeErrors.first('amount') }}</b-form-invalid-feedback>
                    </b-form-group>
                </div>
            </div>

            <div class="mt-4 ml-4 mb-4 clearfix" style="margin-right: 18px;">
                <b-button class="border rounded bg-light float-right py-1 px-5 mt-4 ml-2" type="submit" variant="primary">Submit</b-button>
                <b-button class="border rounded bg-light float-right py-1 px-5 mt-4 ml-2 custom-primary" variant="primary" @click="resetForm()">Reset</b-button>
            </div>

        </b-form>
    </b-modal>
</div>

</template>
<script>
    import moment from 'moment';

    export default{

        mounted() {

            //console.log(this.employee_id);
        },
        props: [ 'flg'],
        data(){

            return {
                itabIndex : 0,
                fiscal_year : this.getCurrentFinancialYear(),
                months: [{ value: 0, text: "N/A" },{ value: 1, text: "January" },{ value: 2, text: "February"},{ value: 3, text: "March"},{ value: 4, text: "April"},{ value: 5, text: "May"},{ value: 6, text: "June"},{ value: 7, text: "July"},{ value: 8, text: "August"},{ value: 9, text: "September"},{ value: 10, text: "October"},{ value: 11, text: "November"},{ value: 12, text: "December", } ],

                aits : [],
                year_aits : [],
                show_year_aits : false,
                showoverlay_list : false,
                successmsg:null,
                errormsg:[],
                fdata: {fiscal_year: this.getCurrentFinancialYear() , month:1, amount:null, id:null },


                fiscal_years: this.$fiscal_year_options,

                decimal_setting: 'yes',
                year:null,
                payrunyears:[
                    { value: null, text: "Select Fiscal Year" },
                ],
                modal_title: "Add Advance Income Tax",
                statusMap: {
                    0: 'Pending',
                    1: 'Approved'
                }

            }
        },
        methods:{
            // Mustafijur: 24-05-2026: Starts
            formatMoney: function(amount){
                // var money = Number(amount);
                var cleaned = String(amount).replace(/,/g, '');
                var money = Number(cleaned);

                if(this.$atl_company_number_format == 'no')
                {
                    money = Math.round(money);
                    money = money.toLocaleString();
                }
                else
                {
                    money = money.toLocaleString();
                    if(money=='NaN')
                    money = amount;
                    else{
                    if(money.indexOf(".")<0)
                    money = money+".00";
                    }

                }

                return money;
            },
            // Mustafijur: 24-05-2026: Starts
            formatMe(d)
            {
                return moment(d).format('YYYY-MM-DD hh:mm:ss A');
            },
            moneyFormat(amount)
            {
                var money = Number(amount);
                money = money.toLocaleString();
                if(this.decimal_setting == 'yes' || this.decimal_setting == '')
                    if(money.indexOf(".")<0)
                        money = money+'.00';
                return money;
            },
            getAits: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                this.year_aits = [];
                this.show_year_aits = false;
                axios.get(this.$api_url+'/front/ait/list' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    currentObj.aits = response.data || {};
                    currentObj.tabIndex = 1;
                    currentObj.payrunyears = [];
                    currentObj.payrunyears.push({value: null,text: 'Select Fiscal Year'});
                    //Object.values(this.aits).forEach(val => this.payrunyears.push({value: val.fiscal_year,text: val.fiscal_year}));
                    /* currentObj.aits.forEach(val => {
                        currentObj.payrunyears.push({value: val.fiscal_year,text: val.fiscal_year});
                        if(val.fiscal_year == currentObj.getCurrentFinancialYear())
                        {
                            currentObj.year = currentObj.getCurrentFinancialYear();
                        }
                    }); */
                    Object.values(currentObj.aits).forEach(val => {
                        currentObj.payrunyears.push({value: val.fiscal_year,text: val.fiscal_year});
                        if(val.fiscal_year == currentObj.getCurrentFinancialYear())
                        {
                            currentObj.year = currentObj.getCurrentFinancialYear();
                        }
                    });
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },
            showAit:function(x)
            {
                this.fiscal_year = x;
                this.year_aits = this.aits[x].details;
                this.show_year_aits = true;
            },
            editAit:function(x)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/front/ait/details' , {
                    params: {
                        id: x
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    this.successmsg = null;
                    this.itabIndex = 0;

                    this.modal_title = "Edit Advance Income Tax"; // Mustafijur: 18-05-2026
                    this.$bvModal.show('bv-modal-example');
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },

            deleteAit:function(x)
            {
                if(!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm if you want to delete this entry.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {
                    if(value)
                    {
                        this.resetForm();
                        this.fdata = {id:null};
                        this.showoverlay_list = true;
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url+'/front/ait/delete', formData).then(function(response){

                            this.getAits();
                            this.year = null;
                            // if(response.data.status == true)
                            // {
                                this.successmsg = response.data.meg;
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                            // }
                            this.showoverlay_list = false;

                        }.bind(this)).catch(function (error){ currentObj.showoverlay_list = false; currentObj.serverError(error);});
                    }
                })
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
               //this.fdata = {fiscal_year:this.getCurrentFinancialYear(), amount:null};
               this.fdata.fiscal_year = null;
               this.fdata.month = null;
               this.fdata.amount = null;

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            addNew()
            {
                this.resetForm();
                this.fdata = {id:null};
                this.modal_title = "Add Advance Income Tax"; // Mustafijur: 18-05-2026
                this.$bvModal.show('bv-modal-example');
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        //headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }

                    axios.post(this.$api_url+'/front/ait/save', formData, config)
                        .then(function (response)
                        {
                            this.resetForm();
                            this.fdata = {id:null};
                            this.getAits();
                            this.itabIndex = 1;

                            this.$bvToast.toast("Saved", {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.serverError(error);
                            //currentObj.errormsg = error.response.data.errors;
                        });

                        this.$bvModal.hide('bv-modal-example');
                });
            },

            get_decimal_settings: function()
            {
              axios.get(this.$api_url+'/front/decimal-settings')

              .then(function (response) {
                this.decimal_setting = response.data;
              }.bind(this));
            },

            // Approver update
            canModifyAit(ait_details, approver_enabled) {
                return approver_enabled == 1
                    ? ait_details.status == 0
                    : ait_details.flg == 1;
            },
            // Approver update

        },
        created: function(){
            this.getAits();
            this.get_decimal_settings();
        }
    }
</script>
